function calculateRowItem(row)  {

    const factor_icbper = parseFloat(row.factor_icbper);
    let price_type_id = '01';
    let quantity = row.quantity;
    let unit_price = parseFloat(row.unit_price);
    let unit_value = parseFloat(row.unit_value);
    let total_base_igv = 0;
    let total_igv = 0;
    let total_plastic_bag_taxes = 0;
    let total_taxes = 0;
    let total_value = 0;
    let total_charge = 0;
    let total_discount = 0;
    let total = 0;

    let has_isc = row.has_isc;

    if (['10', '20', '30', '40'].indexOf(row.affectation_igv_type_id) < 0) {
        price_type_id = '02';
    }

    if (row.has_icbper) {
        total_plastic_bag_taxes = quantity * factor_icbper;
    }

    let discounts = [];

    // _.forEach(row.discounts,  (discount) => {
    //     if (discount.is_amount) {
    //
    //     }
    //
    //     let percentage = parseFloat(discount.percentage);
    //
    //     discounts.push({
    //         'base': '',
    //         'amount': '',
    //         'percentage':  percentage,
    //         'factor': _.round(percentage / 100, 5)
    //     })
    // })

    if (row.affectation_igv_type_id === '10') {
        unit_price = unit_price * (1 - 0);

        total_base_igv = _.round(quantity * unit_value * (1 - 0), 2)
        total = _.round(quantity * unit_price * (1 - 0), 2);
        total_discount = _.round(quantity * unit_price - total, 2);
        total_igv = total - total_base_igv;
        total_taxes = total_igv + total_plastic_bag_taxes;
        total_value = total_base_igv;
        total += total_plastic_bag_taxes;


        // if (row.discount_percentage > 0) {
        //     discounts.push({
        //         'discount_type_id': '00',
        //         'description': 'Descuento del ' + (row.discount_percentage * 100) + '%',
        //         'factor': row.discount_percentage,
        //         'amount': _.round(quantity * unit_value * row.discount_percentage, 2),
        //         'base': _.round(quantity * unit_value, 2),
        //     });
        // }
    }

    if (row.affectation_igv_type_id === '20') {
        total = quantity * unit_price;
        total_value = total;
        total_base_igv = total;
        total_taxes = total_plastic_bag_taxes;
        total += total_taxes;
    }

    if (row.affectation_igv_type_id === '30') {
        total = quantity * unit_price;
        total_value = total;
        total_base_igv = total;
        total_taxes = total_plastic_bag_taxes;
        total += total_taxes;
    }

    if (row.affectation_igv_type_id === '40') {
        total = quantity * unit_price;
        total_value = total;
        total_base_igv = total;
        total_taxes = total_plastic_bag_taxes;
        total += total_taxes;
    }

    if (['11', '12', '13', '14', '15', '16', '17'].indexOf(row.affectation_igv_type_id) > -1) {
        total_base_igv = quantity * unit_value;
        total_igv = quantity * unit_price - total_base_igv;
        total_value = total_base_igv;
        total_taxes = total_plastic_bag_taxes;
        total = total_plastic_bag_taxes;
    }

    if (['21'].indexOf(row.affectation_igv_type_id) > -1) {
        total_value = quantity * unit_price;
        total_base_igv = total_value;
        total_taxes = total_plastic_bag_taxes;
        total = 0;
    }

    if (['31', '32', '33', '34', '35', '36', '37'].indexOf(row.affectation_igv_type_id) > -1) {
        total_value = quantity * unit_price;
        total_base_igv = total_value;
        total_taxes = total_plastic_bag_taxes;
        total = 0;
    }

    return {
        'index': row.index,
        'item_id': row.item_id,
        'name': row.name,
        'item': row.item,
        'currency_type_id': row.currency_type_id,

        'unit_type_id': row.unit_type_id,
        'quantity': row.quantity,
        'price_type_id': price_type_id,
        'has_igv': row.has_igv,
        'unit_value': unit_value,
        'unit_price': unit_price,

        'affectation_igv_type_id': row.affectation_igv_type_id,
        'affectation_igv_type_name': row.affectation_igv_type_name,
        'total_base_igv': total_base_igv,
        'percentage_igv': row.percentage_igv * 100,
        'total_igv': total_igv,

        'system_isc_type_id': has_isc ? row.system_isc_type_id : null,
        'total_base_isc': 0,
        'percentage_isc': has_isc ? parseFloat(row.percentage_isc) : 0,
        'total_isc': 0,

        'total_base_other_taxes': 0,
        'percentage_other_taxes': 0,
        'total_other_taxes': 0,

        'factor_icbper': factor_icbper,
        'total_plastic_bag_taxes': total_plastic_bag_taxes,

        'total_taxes': total_taxes,
        'total_charge': total_charge,
        'total_discount': total_discount,
        'total_value': total_value,
        'total': total,

        'input_unit_price_value': row.input_unit_price_value,

        'attributes': row.attributes,
        'charges': row.charges,
        'discounts': discounts,
        'warehouse_id': row.warehouse_id,

        // purchase_unit_price: row.item.purchase_unit_price,
        // purchase_unit_value: row.item.purchase_unit_value,
        // purchase_has_igv: row.item.has_igv,

        'data_item_lot_group': getDataItemLotGroup(row),
        'activate_discount_on_discount': row.hasOwnProperty('activate_discount_on_discount') ? row.activate_discount_on_discount : false,

    }
}


/*
* Monto de descuento por linea
* Retorna el valor dependiendo del input asignado para monto de descuento (use_input_amount)
* use_input_amount propiedad para determinar si se toma el valor de discount.amount
* y no de discount.percentage cuando es descuento por monto
*/
function getAmountFromInputDiscount(discount) {
    let value = 0

    if (discount.use_input_amount !== undefined && discount.use_input_amount === true) {
        value = _.round(discount.amount, 2)
    } else {
        //flujo antiguo con propiedad no regularizada (algunos componentes item.vue lo usan)
        value = _.round(discount.percentage, 2)
    }

    return value
}


function getUniqueArray(arr, keyProps) {
    if (arr == null) return null
    return Object.values(
        arr.reduce((uniqueMap, entry) => {
            const key = keyProps.map((k) => entry[k]).join('|')
            if (!(key in uniqueMap)) uniqueMap[key] = entry
            return uniqueMap
        }, {})
    )
}

function showNamePdfOfDescription(item, show_pdf_name) {
    if (show_pdf_name !== undefined &&
        show_pdf_name === true &&
        item !== undefined &&
        item.name_product_pdf !== undefined &&
        item.name_product_pdf !== null
    ) {
        let temn = item.name_product_pdf;
        temn = temn.substring(3)
        temn = temn.slice(0, -4)
        if (temn.length > 0) {
            return temn;
        }
    }
    return item.description
}

function sumAmountDiscountsNoBaseByItem(row) {

    let sum_discount_no_base = 0

    if (row.discounts) {
        // if(row.discounts.length > 0){
        sum_discount_no_base = _.sumBy(row.discounts, function (discount) {
            return (discount.discount_type_id == '01') ? discount.amount : 0
        })
        // }
    }

    return sum_discount_no_base
}

function FormatUnitPriceRow(unit_price) {
    return _.round(unit_price, 6)
    // return unit_price.toFixed(6)
}


const filterWords = (input, items) => {
    let search_value = input.toLowerCase();
    return items.filter((item) => {
        let text_filter = item.text_filter.toLowerCase();
        return !search_value.split(' ')
            .some(p => !text_filter.includes(p));
    });
}


/**
 *
 * Retorna datos del lote en la edicion de compra
 *
 */
function getDataItemLotGroup(row_old) {
    let data = null

    if (row_old.date_of_due && row_old.lot_code) {
        data = {
            date_of_due: row_old.date_of_due,
            lot_code: row_old.lot_code,
            item_lot_group_id: row_old.item_lot_group_id,
        }
    }

    return data
}


export {
    calculateRowItem, getUniqueArray, showNamePdfOfDescription,
    sumAmountDiscountsNoBaseByItem, FormatUnitPriceRow, filterWords
}
